export { default } from './UserAssignmentsContainer';
